import { render, staticRenderFns } from "./DNSOutlined.vue?vue&type=template&id=0fc91fe2&"
import script from "./DNSOutlined.vue?vue&type=script&lang=js&"
export * from "./DNSOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports